import { GenderEnum } from '../enums/GenderEnum';

export const Configuration = {
  userRegisterForms: [
    {
      fieldId: 'firstName',
      label: 'firstName',
      type: 'input',
      rowSize: 1,
      required: true,
    },
    {
      fieldId: 'lastName',
      label: 'lastName',
      type: 'input',
      rowSize: 1,
      required: true,
    },
    {
      fieldId: 'email',
      label: 'email',
      type: 'email',
      rowSize: 1,
      required: true,
    },
    {
      fieldId: 'role',
      label: 'role',
      type: 'select',
      rowSize: 1,
      required: true,
      values: [],
    },
    {
      fieldId: 'organization',
      label: 'organization',
      type: 'input',
      rowSize: 1,
      required: false,
    },
    {
      fieldId: 'position',
      label: 'position',
      type: 'input',
      rowSize: 1,
      required: false,
    },
    {
      fieldId: 'department',
      label: 'department',
      type: 'input',
      rowSize: 1,
      required: false,
    },
  ],

  userTypeRegisterForms: [
    {
      fieldId: 'name',
      label: 'roleName',
      type: 'input',
      rowSize: 1,
      required: true,
    },
    {
      fieldId: 'shortName',
      label: 'roleCode',
      type: 'input',
      rowSize: 1,
      required: true,
    },
    {
      fieldId: 'description',
      label: 'description',
      type: 'input',
      rowSize: 1,
      required: true,
    },
  ],
  languages: [
    {
      id: 'english',
      label: 'English',
      symbol: 'en',
    },
    {
      id: 'spanish',
      label: 'Spanish',
      symbol: 'es',
    },
  ],
  gender: [
    {
      value: GenderEnum.MALE,
      label: 'Male',
    },
    {
      value: GenderEnum.FEMALE,
      label: 'Female',
    },
    {
      value: GenderEnum.OTHER,
      label: 'Do not want to disclose',
    },
  ],

  dummyOptions: [
    {
      value: 'dummy1',
      label: 'dummy1',
    },
    {
      value: 'dummy2',
      label: 'dummy2',
    },
    {
      value: 'dummy3',
      label: 'dummy3',
    },
  ],

  // Default location configuration for citizen portal
  defaultLocation: {
    department: 'Francisco Morazán',
    municipality: 'Distrito Central',
  },
};

export const ONLINE_FIRST_ENTITIES = new Set(['mainProduct', 'basket']);
